import './LoginComponent.less';
import Icon from '@/components/iconfont/Icon.jsx';

import Login from '@/pages/login/index.jsx';
import Signup from '@/pages/signup/index.jsx';
import Verify from '@/pages/verify/index.jsx';
import ForgotPassword from '@/pages/forgotPassword/index.jsx';
import SetPassword from '@/pages/setPassword/index.jsx';
import SetPasswordSuccess from '@/pages/setpasswordsuccess/index.jsx';
import { useState, useEffect } from 'react';

export default function LoginComponent({ loginFlag, setLoginFlag, setUserDetailUpdate, showBg }) {
  const [currentPage, setCurrentPage] = useState('login');
  useEffect(() => {
    if (!loginFlag) {
      setCurrentPage('login');
    }
  }, [loginFlag]);

  const handleLoginBack = () => {
    setCurrentPage('login');
  };
  return (
    <div className="login_component_box" style={{ background: showBg && 'rgba(0, 0, 0, 0.3)' }}>
      {/* <button>Login/Register</button> */}
      <div className="login_component">
        {currentPage !== 'login' && currentPage !== 'signup' && (
          <div className="login_callback" onClick={handleLoginBack}>
            <Icon name="icon-arrow-left" className="back_icon" />
            <span>Login / Register</span>
          </div>
        )}
        {currentPage === 'login' && (
          <Login
            setCurrentPage={setCurrentPage}
            setLoginFlag={setLoginFlag}
            setUserDetailUpdate={setUserDetailUpdate}
          />
        )}
        {currentPage === 'signup' && <Signup setCurrentPage={setCurrentPage} />}
        {currentPage === 'verify' && <Verify setCurrentPage={setCurrentPage} />}
        {currentPage === 'forgotPassword' && <ForgotPassword setCurrentPage={setCurrentPage} />}
        {currentPage === 'setPassword' && (
          <SetPassword
            setCurrentPage={setCurrentPage}
            setLoginFlag={setLoginFlag}
            setUserDetailUpdate={setUserDetailUpdate}
          />
        )}
        {currentPage === 'setPasswordSuccess' && (
          <SetPasswordSuccess setCurrentPage={setCurrentPage} />
        )}
      </div>
    </div>
  );
}
